import { useNavigate } from 'react-router-dom'
import cn from 'clsx'
import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {Text, Button} from 'common/components'
import {
  MilestoneAction, CheckActionsProps,
  MilestoneCheck, MilestoneCheckProps,
  RequestDecline,
  useAcceptRequestStatus,
  isMilestonePassed,
  isAllMilestonesPassed,
  // isFirstManagerActionsChecked,
} from '..'

// const ORDERED_MILESTONES =[
//   'documents-checked',
//   'forecast-created',
//   'establish-fee-checked',
//   'line-fee-checked',
//   'facility-limit-2-checked',
// ]
// const findLastMilestone = (milestones:any[], order:string[]) => {
//   const orderIndex = order.reduce((accu:any, k:string, index:number) => {
//     accu[k] = index
//     return accu
//   }, ({} as any))
//   const passed = milestones.filter((x:any) => (
//     !!x.passed
//   )).sort((a:any, b:any) => (orderIndex[a.type] < orderIndex[b.type]) ? -1:1)
//   // console.log(orderIndex)
//   // console.log(passed)
//   const last = passed.at(-1)
//   // console.log(last)
//   return last
// }

export default function ManagerCheckActions({
  role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const navigate = useNavigate()
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid)
  
  const handleStatusAccept = () => acceptRequestStatus()

  // const hasAssignBorrowerCheck = request.milestones.some(
  //   (milestone: any) => milestone.type === 'borrower-assigned'
  // )
  // const hasUpdateForecastCheck = request.milestones.some(
  //   (milestone: any) => milestone.type === 'forecast-updated'
  // )

  // console.table(request?.milestones)
  // const isLastActionsDisabled = !isFirstManagerActionsChecked(request)
  const isStatusAcceptDisabled = 
    isRequestLoading ||
    ( !isAllMilestonesPassed(request, [
      'documents-checked',
      'forecast-created',
      'establish-fee-checked',
      'line-fee-checked',
      'facility-limit-2-checked',
    ]) )

  const isNotAllowed = (!permissions?.includes('edit variation request (lm check)'))
  const isCreateForecastNotAllowed = (!permissions?.includes('edit variation forecast'))

  // const lastMilestone = findLastMilestone(request.milestones, ORDERED_MILESTONES)
  // console.log(lastMilestone)

  return (
    <div className={commonStyles.checkActions}>
      <div className={commonStyles.checkActionsBlock}>
        <Text size="xs">
          <Text as="span" weight="demiBold">
            Lending manager
          </Text>
          <br />
          responsible to do:
        </Text>
        <div className={cn(commonStyles.checkActionsMilestones, commonStyles['align-items-top'])}>
          <div>
            <MilestoneCheck
              tag='variation'
              type="documents-checked"
              request={request}
              disabled={isNotAllowed}
              onArrowClick={() => navigate('documents')}
            />
            <ForecastCheck
              request={request}
              disabled={
                !isMilestonePassed('documents-checked', request) || 
                isNotAllowed ||
                isCreateForecastNotAllowed
              } 
            />
          </div>
          <div>
            <EstablishmentFeeCheck
              request={request}
              disabled={!isMilestonePassed('forecast-created', request) || isNotAllowed}
            />
            <LineFeeCheck
              request={request}
              disabled={!isMilestonePassed('establish-fee-checked', request) || isNotAllowed}
            />
          </div>
          <div>
            <FacilityLimit2Check
              request={request}
              disabled={!isMilestonePassed('line-fee-checked', request) || isNotAllowed}
            />
          </div>
        </div>
      </div>
      { !isNotAllowed && (
        <div>
          <Button
            className={commonStyles.checkActionsButton}
            loading={isAcceptRequestStatusMutating}
            disabled={isStatusAcceptDisabled}
            onClick={handleStatusAccept}
          >
            Check has been done
          </Button>
          <RequestDecline
            requestUuid={request.uuid}
            requestStatus={request.status}
            disabled={isRequestLoading}
            tag="variation"
          />
        </div>
      )}
    </div>
  )
}

const ForecastCheck = ({request, disabled}: MilestoneCheckProps) => {
  const setForecastOpen = useStore((state) => state.setVariationForecastOpen)
  const handleCheck = () => setForecastOpen(true)

  return (
    <MilestoneAction
      type="forecast-created"
      milestones={request.milestones}
      disabled={disabled}
      onClick={handleCheck}
    />
  )
}

const EstablishmentFeeCheck = ({request, disabled}: MilestoneCheckProps) => {
  const setOpenKey = useStore((state) => state.setVariationEstablishmentFeeOpenKey)
  const handleCheck = () => setOpenKey('1st')

  return (
    <MilestoneAction
      tag="variation"
      type='establish-fee-checked'
      milestones={request.milestones}
      disabled={disabled}
      onClick={handleCheck}
    />
  )
}

const LineFeeCheck = ({request, disabled}: MilestoneCheckProps) => {
  const setOpenKey = useStore((state) => state.setVariationLineFeeOpenKey)
  const handleCheck = () => setOpenKey('1st')

  return (
    <MilestoneAction
      tag="variation"
      type='line-fee-checked'
      milestones={request.milestones}
      disabled={disabled}
      onClick={handleCheck}
    />
  )
}

const FacilityLimit2Check = ({request, disabled}: MilestoneCheckProps) => {
  const setOpenKey = useStore((state) => state.setVariationFacilityLimit2OpenKey)
  const handleCheck = () => setOpenKey('1st')

  return (
    <MilestoneAction
      tag="variation"
      type='facility-limit-2-checked'
      milestones={request.milestones}
      disabled={disabled}
      onClick={handleCheck}
    />
  )
}
